<template>
  <div class="user-info">
    <b-form>
      <b-form-group
        label="帳號"
        label-for="user-center-account"
        class="required-icon-star"
      >
        <b-form-input
          id="user-center-account"
          :value="$store.getters.userInfo.account"
          type="text"
          disabled
        ></b-form-input>
      </b-form-group>
      <b-form-group
        label="真實姓名"
        label-for="user-center-name"
        class="required-icon-star"
      >
        <b-form-input
          id="user-center-name"
          @input="update('name', $event)"
          :value="$store.getters.userInfo.name"
          :state="verifyName"
          :title="'輸入格式有誤'"
          type="text"
          required
          placeholder=""
        ></b-form-input>
      </b-form-group>
      <b-form-group
        label="email"
        label-for="user-center-email"
        class="required-icon-star"
      >
        <b-form-input
          id="user-center-email"
          @input="update('email', $event)"
          :value="$store.getters.userInfo.email"
          :state="verifyEmail"
          :title="'輸入格式有誤'"
          type="text"
          required
          placeholder=""
        ></b-form-input>
      </b-form-group>
      <b-form-group
        label="手機"
        label-for="user-center-phone"
        class="required-icon-star"
      >
        <b-form-input
          id="user-center-phone"
          @input="update('phone', $event)"
          :value="$store.getters.userInfo.phone"
          :state="verifyPhone"
          :title="'輸入格式有誤'"
          type="text"
          required
          placeholder=""
        ></b-form-input>
      </b-form-group>
      <b-form-group label="投資資歷" label-for="user-center-seniority">
        <b-form-input
          id="user-center-seniority"
          @input="update('seniority', $event)"
          :value="$store.getters.userInfo.seniority"
          :state="verifySeniority"
          :title="'輸入格式有誤'"
          type="text"
          maxlength="2"
          required
          placeholder=""
        ></b-form-input
        >年
      </b-form-group>
      <b-form-group label="自我介紹" label-for="user-center-introduction">
        <b-form-textarea
          id="user-center-introduction"
          @input="update('introduction', $event)"
          :value="$store.getters.userInfo.introduction"
          :state="verifyIntroduction"
          :title="'輸入格式有誤'"
          placeholder="請在 255 字內簡單自我介紹"
          rows="5"
        ></b-form-textarea>
      </b-form-group>
      <div class="text-right">
        <b-button
          class="mr-3"
          type="button"
          variant="primary"
          @click="verifyForm"
          >修改</b-button
        >
        <b-button class="mr-3" type="button" variant="dark" @click="cancel"
          >取消</b-button
        >
      </div>
    </b-form>

    <!-- modal -->
    <b-modal ref="update-info">
      <p class="text-center">是否修改個人資料？</p>
      <template v-slot:modal-footer>
        <div class="text-center">
          <b-button @click="submit" class="mr-3" type="button" variant="primary"
            >送出</b-button
          >
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import mixinsVerify from "@/utility/mixinsVerify.js";
export default {
  mixins: [mixinsVerify],
  methods: {
    verifyForm() {
      this.verifyName = this.hasValue(this.$store.getters.userInfo.name);
      this.verifyEmail =
        this.hasValue(this.$store.getters.userInfo.email) === null
          ? this.emailRegexp(this.$store.getters.userInfo.email)
          : false;
      this.verifyPhone =
        this.hasValue(this.$store.getters.userInfo.phone) === null
          ? this.phoneRegexp(this.$store.getters.userInfo.phone)
          : false;
      this.verifySeniority = Number.isNaN(
        Number(this.$store.getters.userInfo.seniority)
      )
        ? false
        : null;
      this.verifyIntroduction = this.introductionRegexp(
        this.$store.getters.userInfo.introduction
      );
      if (
        this.verifyName === false ||
        this.verifyEmail === false ||
        this.verifyPhone === false ||
        this.verifySeniority === false ||
        this.verifyIntroduction === false
      )
        return;
      else this.$refs["update-info"].show();
    },
    update(key, value) {
      let updateObj = {};
      updateObj[key] = value;
      this.$store.commit(
        "userInfo",
        Object.assign({}, this.$store.getters.userInfo, updateObj)
      );
    },
    submit() {
      this.$refs["update-info"].hide();
      this.$store.dispatch("updateUserInfo");
    },
    cancel() {
      this.verifyName = null;
      this.verifyEmail = null;
      this.verifyPhone = null;
      this.verifySeniority = null;
      this.verifyIntroduction = null;
      this.$store.dispatch("fetchUserInfo");
    }
  }
};
</script>

<style lang="scss" scoped></style>
